import { User } from 'src/types/user';
import { Instance } from 'src/types/instance';
import { log1flowEvent, logUser } from './1flow';
import * as amplitude from './amplitude';
import * as sentry from './sentry';
import * as clarity from './clarity';

export const setUser = (user?: User, instance?: Instance) => {
  sentry.setUser(user, instance);
  amplitude.setUser(user, instance);
  clarity.setUser(user, instance);

  logUser(String(user.id), {
    instanceId: instance.id,
  });
};

export const clearUser = () => {
  sentry.clearUser();
  amplitude.clearUser();
  clarity.clearUser();
};

export const logEvent = (
  eventName: string,
  eventProperties?: Record<string, unknown>,
) => {
  amplitude.logEvent(eventName, eventProperties);
  log1flowEvent(eventName, eventProperties);
};
